import axios from '@/api/axios';
import Vue from 'vue';
import Vapi from 'vuex-rest-api';

const store = new Vapi({
  axios,
  state: {
    discounts: [],
  },
})
  .get({
    action: 'getDiscounts',
    property: 'discounts',
    path: ({ catalogId }) => `/shop/${catalogId}/discounts`,
  })
  .get({
    action: 'getDiscount',
    path: ({ catalogId, discountId }) => `/shop/${catalogId}/discounts/${discountId}`,
  })
  .post({
    action: 'createDiscount',
    path: ({ catalogId }) => `/shop/${catalogId}/discounts`,
    onSuccess: (s, { data }) => {
      s.discounts.push(data);
    },
  })
  .put({
    action: 'updateDiscount',
    path: ({ catalogId, discountId }) => `/shop/${catalogId}/discounts/${discountId}`,
    onSuccess: (s, { data }) => {
      const index = s.discounts.findIndex((x) => x.id === data.id);
      if (index !== -1) {
        Vue.set(s.discounts, index, data);
      }
    },
  })
  .delete({
    action: 'deleteDiscount',
    path: ({ catalogId, discountId }) => `/shop/${catalogId}/discounts/${discountId}`,
    onSuccess: (s, _, a, { params }) => {
      s.discounts = s.discounts.filter((x) => x.id !== params.discountId);
    },
  })
  .getStore();

store.getters = {
  discounts: (s) => s.discounts,
};

export default store;
